import React from "react";

import img1 from "../../assets/images/friendlyArival.png";
import img2 from "../../assets/images/friendlyArvial2.png";
import img3 from "../../assets/images/firendlyArival3.png";
import img4 from "../../assets/images/friendlyArival4.png";
import { useNavigate } from "react-router-dom";

const items = [
  { title: "New Arrivals", img: img1 },
  { title: "Fresh Deli Deals", img: img2 },
  { title: "Huge Chip Selection", img: img3 },
  { title: "Frozen Treats", img: img4 },
];

const ShoppingSection = () => {
  const navigate = useNavigate();

  return (
    <section id="shopping-section">
      <div className="wrapper">
        <h2>More to grab while you're here</h2>

        <div className="shopping-list">
          {items.map((item, index) => (
            <div className="shopping-card" key={index} onClick={() => navigate("/store")}>
              <div className="img-wrap">
                <img src={item.img} alt={item.title} />
              </div>
              <p>
                {item.title} <span>›</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShoppingSection;
